export const MAX_ALLOWED_DATE = '9999-12-31T23:59';
